S.video =
    {
        elements: {
            $video: null,
            $image: null,
            $mask: null,
        },

        init()
        {
            if (this.elements.$video.parents('.mod-stage-media') && !this.elements.$video.parents('.mod-xmas-text-media'))
            {
                if (this.elements.$video.prop('tagName') !== 'IFRAME')
                {
                    this.elements.$video.height(this.elements.$video.width() / 1.77);
                    $(window).resize(() =>
                    {
                        this.elements.$video.height(this.elements.$video.width() / 1.77);
                    });
                }
            }

            this.elements.$video.click((event) =>
            {
                $(event.currentTarget).get(0).pause();
                S.mediastage.showHeader();
                S.buttonPlay.instances[0].$module.show();
                if (this.elements.$image)
                {
                    this.elements.$image.show();
                }
            });

            this.elements.$video.on('ended', () =>
            {
                S.buttonPlay.instances[0].$module.show();
                if (this.elements.$image)
                {
                    this.elements.$image.show();
                }
                S.mediastage.showHeader();
            });
        },
    };
